import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../services/api';
// Import your logo file from 'assets'
import logo from '../assets/landinglogo.jpg';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post('/auth/login', { email, password });
      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      if (user.role === 'THERAPIST') {
        navigate('/therapist/dashboard');
      } else if (user.role === 'OFFICE_ADMIN' || user.role === 'PORTAL_ADMIN') {
        navigate('/admin/dashboard');
      } else {
        navigate('/therapist/dashboard'); // fallback
      }
    } catch (err) {
      console.error(err);
      alert('Invalid credentials');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'flex-start', // changed from center
        alignItems: 'center',
        background: '#f0f0f0',
        paddingTop: '4rem', // push it down from the top a bit
      }}
    >
      <div
        style={{
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '2rem',
          width: '300px',
          textAlign: 'center',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        }}
      >
        {/* Logo at top */}
        <img
          src={logo}
          alt="Logo"
          style={{ width: '175px', marginBottom: '1rem' }}
        />

        <h2 style={{ marginBottom: '1rem' }}></h2>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
            <label>Email:</label>
            <br />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.5rem',
                boxSizing: 'border-box',
                marginTop: '0.25rem',
              }}
            />
          </div>

          <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
            <label>Password:</label>
            <br />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.5rem',
                boxSizing: 'border-box',
                marginTop: '0.25rem',
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#1D2C5F',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Login
          </button>

          <div style={{ marginTop: '0.75rem', textAlign: 'center' }}>
            <Link to="/forgot-password" style={{ color: '#C67A52', fontSize: '0.85rem' }}>
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
